// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__ztC5G","dark":"Button_dark__KcnCp","light":"Button_light__lBCMl"};